import useOrgUnitAdminPayments from './UseOrgUnitAdminPayments';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import ShoppingCart from '@usas/ui-web/components/payments/ShoppingCart';

const OrgUnitAdminPayments = () => {
  const {
    redirectToPurchases,
    redirectToEntryStatus,
    orgUnitId,
    omeMeetOrgUnitEntryId
  } = useOrgUnitAdminPayments();

  return (
    <ViewTemplate
      viewName={Views.OME_MEET_SUBMIT}>
      <ShoppingCart isBarOnBottom={false} orgUnitId={orgUnitId} itemSubsystemId={3} itemContract={5} referenceId={omeMeetOrgUnitEntryId} onPaymentCompletion={redirectToEntryStatus} onPaymentCancel={redirectToPurchases}></ShoppingCart>
    </ViewTemplate>
  );
};

export default OrgUnitAdminPayments;
